export default "__VITE_ASSET__KOQ5zuW8__"